import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useOverlayContext } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { ErrorResponse, ServerError, errorTextsPath } from '~/infra/ErrorResponse';
import { CONTACT_FIELD_NAME, editContactIdentityModalTextsPath } from '../EditContactIdentityModal.utils';
import { useSaveContactIdentity } from './useSaveContactIdentity';
export const useSubmitContactIdentity = (param)=>{
    let { contact, dismissModal, successToastTestId, guardTestIds } = param;
    const { t } = useLocaleKeys(editContactIdentityModalTextsPath);
    const { t: errorTexts } = useLocaleKeys(errorTextsPath);
    const { showSuccessToast } = useOverlayContext();
    const { setError } = useFormContext();
    const saveContactIdentity = useSaveContactIdentity(guardTestIds);
    const [errorMessage, setErrorMessage] = useState(null);
    const reportFailure = (error)=>{
        const response = new ErrorResponse(error);
        if (response.hasServerError([
            ServerError.DuplicateContact,
            ServerError.DuplicateContactIdentity
        ])) {
            setError("".concat(CONTACT_FIELD_NAME, ".email"), {
                message: t.duplicateEmailError()
            });
            return;
        }
        setErrorMessage(response.saveContactErrorText(errorTexts));
    };
    const submit = async (param)=>{
        let { contact: formContact } = param;
        setErrorMessage(null);
        try {
            await saveContactIdentity(contact, formContact);
        } catch (error) {
            reportFailure(error);
            return;
        }
        showSuccessToast(t.contactUpdated(), successToastTestId);
        dismissModal();
    };
    return {
        errorMessage,
        submit
    };
};
